import type { LicenseEntitlementBooleanKey, LicenseEntitlementNumericKey } from '#layers/license/types/license';
import { entitlementTitleKey } from '#layers/license/utils/entitlement-title-key';

interface LicenseEntitlementDisplayNumericConfig {
	kind: 'numeric';
	id: LicenseEntitlementNumericKey;
	icon: string;
	titleKey: string;
}

export interface LicenseEntitlementDisplayBooleanConfig {
	kind: 'boolean';
	id: LicenseEntitlementBooleanKey;
	icon: string;
	titleKey: string;
	/** Negate the truth value before labeling (e.g. telemetry opt-out). */
	invert?: boolean;
	/** Replaces "Included" and "Not Included" where they don't read naturally (e.g. telemetry). */
	valueLabelKeys?: { included: string; notIncluded: string };
}

type LicenseEntitlementDisplayConfig = LicenseEntitlementDisplayNumericConfig | LicenseEntitlementDisplayBooleanConfig;

export const LICENSE_ENTITLEMENT_DISPLAY_CONFIG: LicenseEntitlementDisplayConfig[] = [
	{ kind: 'numeric', id: 'workspaces', icon: 'lucide:layout-grid', titleKey: entitlementTitleKey('workspaces') },
	{ kind: 'numeric', id: 'seats', icon: 'lucide:users', titleKey: entitlementTitleKey('seats') },
	{ kind: 'numeric', id: 'custom_roles', icon: 'lucide:shield-ellipsis', titleKey: entitlementTitleKey('custom_roles') },
	{ kind: 'numeric', id: 'custom_policies', icon: 'material-symbols:article-outline', titleKey: entitlementTitleKey('custom_policies') },
	{ kind: 'numeric', id: 'service_accounts', icon: 'lucide:user-cog', titleKey: entitlementTitleKey('service_accounts') },
	{ kind: 'boolean', id: 'sso_enabled', icon: 'lucide:key-round', titleKey: entitlementTitleKey('sso_enabled') },
	{ kind: 'boolean', id: 'audit_logs_enabled', icon: 'lucide:logs', titleKey: entitlementTitleKey('audit_logs_enabled') },
	{ kind: 'boolean', id: 'custom_permission_rules_enabled', icon: 'lucide:filter', titleKey: entitlementTitleKey('custom_permission_rules_enabled') },
	{ kind: 'boolean', id: 'offline_enabled', icon: 'lucide:wifi-off', titleKey: entitlementTitleKey('offline_enabled') },
	{ kind: 'boolean', id: 'production_enabled', icon: 'lucide:rocket', titleKey: entitlementTitleKey('production_enabled') },
	{
		kind: 'boolean',
		id: 'telemetry_required',
		icon: 'lucide:chart-no-axes-column',
		titleKey: entitlementTitleKey('telemetry_required'),
		invert: true,
		valueLabelKeys: {
			included: 'organization.dashboard.settings.license.value.optional',
			notIncluded: 'common.required',
		},
	},
];
